import { render, staticRenderFns } from "./GymRouteGradeAndPoint.vue?vue&type=template&id=44c0530c"
import script from "./GymRouteGradeAndPoint.vue?vue&type=script&lang=js"
export * from "./GymRouteGradeAndPoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports